import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ClipboardService } from 'ngx-clipboard';
import { NzMessageService } from 'ng-zorro-antd/message';

const PUBLIC_KEY = `mQGNBGciGQABDACoGOrOnFwCB2LRtVj+7Wn/xY2aYDaczE3suzm6Bq6c39ngt67U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=5cRN`;

@Component({
  selector: 'app-deb-verification-modal',
  templateUrl: './deb-verification-modal.component.html',
  styleUrls: ['./deb-verification-modal.component.scss'],
  standalone: true,
  imports: [NzModalModule, NzCardModule, NzIconModule],
})
export class DebVerificationModalComponent {
  private clipboardService = inject(ClipboardService);
  private messageService = inject(NzMessageService);

  readonly PUBLIC_KEY = PUBLIC_KEY;

  @Input()
  isVerificationModalVisible = false;

  @Output() isVerificationModalVisibleChange = new EventEmitter<boolean>();

  closeVerificationModal(): void {
    this.isVerificationModalVisibleChange.emit(false);
    this.isVerificationModalVisible = false;
  }

  copy(el: HTMLElement): void {
    const text = el.innerText;
    this.clipboardService.copy(text);
    this.messageService.info('Поле скопировано в буфер обмена');
  }
}
